import Literacy from '../views/Literacy'

const LiteracyContainer = () => {
  return <Literacy programDuration={0} />
}

export default LiteracyContainer
